import { createAction } from '../../utils/reduxUtils';
import { ISimpleLocation, ITourSummary } from '../../models';
import { IAsyncError, IInitialBounds } from '../../common';
import { NearbyToursRequest } from './utils/requests';

type FetchInitialBoundsRequest = {
  onSuccess: (initialBounds: IInitialBounds) => void;
};

const fetchInitialBounds = {
  request: createAction('@findTour/FETCH_INITIAL_BOUNDS_REQUEST')<FetchInitialBoundsRequest>,
  success: createAction('@findTour/FETCH_INITIAL_BOUNDS_SUCCESS')<void>,
  failure: createAction('@findTour/FETCH_INITIAL_BOUNDS_FAILURE')<IAsyncError>,
};

const selectTour = createAction('@findTour/selectTour')<string | undefined>;

const fetchNearbyTours = {
  request: createAction('@findTour/FETCH_NEARBY_TOURS_REQUEST')<NearbyToursRequest>,
  start: createAction('@findTour/FETCH_NEARBY_TOURS_START')<{}>,
  success: createAction('@findTour/FETCH_NEARBY_TOURS_SUCCESS')<ITourSummary[]>,
  failure: createAction('@findTour/FETCH_NEARBY_TOURS_FAILURE')<IAsyncError>,
};


const toggleFilter = createAction('@findTour/TOGGLE_FILTER')<{
  key: string;
  value: any;
}>;

const dismissDialog = createAction('@findTour/DISMISS_DIALOG')<void>;

const applyFilters = createAction('@findTour/APPLY_FILTERS')<void>;

// custom action creator
const resetFilters = (apply = false) => ({ type: '@findTour/RESET_FILTERS', payload: undefined, meta: { apply } });
resetFilters.type = '@findTour/RESET_FILTERS';

const hydrateFilters = createAction('@findTour/HYDRATE_FILTERS')<Record<string, any>>;

const toggleList = createAction('@findTour/TOGGLE_LIST')<void>;

const subscribeLocation = createAction('@findTour/SUBSCRIBE_LOCATION')<{
  location: ISimpleLocation;
  showDialog: boolean;
}>;

const actions = {
  fetchNearbyTours,
  selectTour,
  toggleFilter,
  dismissDialog,
  applyFilters,
  resetFilters,
  hydrateFilters,
  fetchInitialBounds,
  toggleList,
  subscribeLocation,
};

export default actions;
